import { render, staticRenderFns } from "./GenericErrorAlert.vue?vue&type=template&id=5924e0ba&"
import script from "./GenericErrorAlert.vue?vue&type=script&lang=js&"
export * from "./GenericErrorAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports